import { Logger } from 'src/app/core/logger';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WidgetsRelatedinputModel } from 'src/app/models/widgets/widgets-related-input.model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'appMetadataRelatedInput',
  templateUrl: './metadata-related-input.component.html',
  styleUrls: ['./metadata-related-input.component.scss']
})
export class MetadataRelatedInputComponent implements OnInit {
  @Input() data: WidgetsRelatedinputModel = new WidgetsRelatedinputModel();

  // https://stackblitz.com/edit/form-array-angular-yvow9n?file=src%2Fapp%2Fapp.component.ts
  // https://stackblitz.com/edit/angular-forms-formarray-example-leedar?file=src%2Fapp%2Fapp.component.html
  form: FormGroup;
  nextValue: number = 0;
  errorMessage: string = '';
  isVisible = true;
  isText = false;
  isNum = false;
  isDisable = false;
  minNum?: number;
  target: any;
  constructor(
    private fb: FormBuilder,
    public cd: ChangeDetectorRef,
    private logger: Logger,

  ) {
    this.form = this.fb.group({
      heading: [this.data.label, Validators.maxLength(30)],
      description: ['', Validators.maxLength(100)],
      options: [this.data.options],
      suffix: [this.data.suffix, Validators.maxLength(30)],
      prefix : [this.data.prefix],
      middlePrefix : [this.data.middlePrefix],
      obtainedInput :'',
      total : ''
    });

    this.setProperties()

  }
  setProperties() {
    this.form.get('heading')?.valueChanges.subscribe(label => {
      this.data.label = this.form.controls.heading.value;
    });
    this.form.get('suffix')?.valueChanges.subscribe(suffixText => {
      this.data.suffix = this.form.controls.suffix.value;
    });
    this.form.get('middlePrefix')?.valueChanges.subscribe(prefixTwo => {
      this.data.middlePrefix = this.form.controls.middlePrefix.value;
    });
    this.form.get('prefix')?.valueChanges.subscribe(prefix => {
      this.data.prefix = this.form.controls.prefix.value;
    });

  }

  ngOnInit(): void {

    this.setFormValues();
  
  }


  setFormValues() {

    {
      if (this.data.options) {
        this.form.controls.options.setValue(this.data.options);
      }
      if (this.data.prefix) {
        this.form.controls.prefix.setValue(this.data.prefix);
      }
      if (this.data.middlePrefix) {
        this.form.controls.middlePrefix.setValue(this.data.middlePrefix);
      }
      if (this.data.suffix) {
        this.form.controls.suffix.setValue(this.data.suffix);
      }
    }
  }
}


